module.exports = __webpack_public_path__ + "media/success.945d3b3a.wav";